import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import LoginActions from "./api/LoginActions";

const ProtectedRoute = () => {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        LoginActions.me(
            user => {
                setIsAuthenticated(true);
                setLoading(false);
            },
            error => {
                setIsAuthenticated(false);
                setLoading(false);
            }
        );
    }, []);

    if(!loading && isAuthenticated) {
        return <Outlet />;
    }

    return null;
}

export default ProtectedRoute;